/**
 * Theme Core v4.0.0
 * ═══════════════════════════════════════════════════════════════════════════════
 *
 * Minimal initialization and glue code.
 *
 * This file is intentionally small. All functionality lives in:
 * - logger.js: Namespaced logging
 * - alpine-stores.js: $store.cart, $store.ui
 * - events.js: Event classes (ES Module)
 * - component-*.js: Web components (ES Modules)
 *
 * ═══════════════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  // Ensure window.Theme exists
  window.Theme = window.Theme || {};

  // Get Logger (loaded before this file)
  const Logger = window.Theme.Logger || {
    ns: () => ({ debug: () => {}, info: () => {}, warn: console.warn, error: console.error })
  };

  const log = Logger.ns('core');

  // ═══════════════════════════════════════════════════════════════════════════════
  // EVENT HELPER
  // ═══════════════════════════════════════════════════════════════════════════════

  /**
   * Subscribe to an event
   * @param {string} name - Event name
   * @param {Function} handler - Event handler
   * @param {EventTarget} [target=document] - Target to listen on
   * @returns {Function} Unsubscribe function
   */
  const on = (name, handler, target = document) => {
    try {
      target.addEventListener(name, handler);
      return () => target.removeEventListener(name, handler);
    } catch (e) {
      return () => {};
    }
  };

  window.Theme.on = on;

  // ═══════════════════════════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════════════════════════

  log.info('Theme core v4.0.0 loaded');
})();
